$(document).ready(function () {
    (function() {
        const ajaxPathRole = '/action/role';
        const ajaxPathRoleForm = '/form';

        let ajaxLockActive = false;

        $(document).on('click', '#role_btn_create', function () {
            if (ajaxLockActive) {
                return false;
            }

            const name = $(document).find('#role_form #role_name').val();
            const description = $(document).find('#role_form #role_description').val();

            if(name == '') {
                alert('Navn kan ikke være tomt!');
                return;
            }

            const permissions = {};
            $('#role_form .permission-checkbox').each(function () {
                const name = $(this).attr('id');
                let value = 0;
                if($(this).is(':checked')) {
                    value = 1;
                }
                permissions[name] = value;
            });

            ajaxLockActive = true;
            showTailwindPreloader();

            $.ajax({
                type: 'POST',
                url: ajaxPathRole,
                data: {
                    name,
                    description,
                    permissions
                },
                dataType: 'json'
            }).success(function (data) {
                $('#role_wrapper').html(data.html);
                reinitTransitions('#role_wrapper');
                $(document).find('#role_list_panel').notify(`Rolle "${name}" er opprettet`, {
                    position: "bottom center",
                    className: 'success'
                });
                $('html, body').animate({scrollTop:0}, 'slow');
            }).error(function (data) {
                const message = data && data.responseJSON && data.responseJSON.error
                    ? data.responseJSON.error
                    : 'Kunne ikke opprette rolle';
                $(document).find('#role_btn_create').notify(message, {
                    position: "right bottom",
                    className: 'error'
                });
            }).always(function () {
                ajaxLockActive = false;
                hideTailwindPreloader();
            });
            return false;
        });

        $(document).on('click', '#role_btn_edit', function () {
            if (ajaxLockActive) {
                return false;
            }

            const roleId = $(document).find('#role_form #role_id').val();
            const name = $(document).find('#role_form #role_name').val();
            const description = $(document).find('#role_form #role_description').val();

            if(roleId <= 0) {
                return;
            }

            if(name == '') {
                alert('Navn kan ikke være tomt!');
                return;
            }

            const permissions = {};
            $('#role_form .permission-checkbox').each(function () {
                const name = $(this).attr('id');
                let value = 0;
                if($(this).is(':checked')) {
                    value = 1;
                }
                permissions[name] = value;
            });

            ajaxLockActive = true;
            showTailwindPreloader();

            $.ajax({
                type: 'POST',
                url: ajaxPathRole + '/' + roleId,
                data: {
                    name,
                    description,
                    role_id: roleId,
                    permissions
                },
                dataType: 'json'
            }).success(function (data) {
                $('#role_wrapper').html(data.html);
                reinitTransitions('#role_wrapper');
                $(document).find('#role_list_panel').notify(`Rolle "${name}" er oppdatert`, {
                    position: "bottom center",
                    className: 'success'
                });
                $('html, body').animate({scrollTop:0}, 'slow');
            }).error(function (data) {
                const message = data && data.responseJSON && data.responseJSON.error
                    ? data.responseJSON.error
                    : 'Kunne ikke oppdatere rolle';
                $(document).find('#role_btn_edit').notify(message, {
                    position: 'right',
                    className: 'error'
                });
            }).always(function () {
                ajaxLockActive = false;
                hideTailwindPreloader();
            });
            return false;
        });

        $(document).on('click', '#role_btn_delete', function () {
            if (ajaxLockActive) {
                return false;
            }

            const roleId = $(document).find('#role_form #role_id').val();
            const name = $(document).find('#role_form #role_name').val();
            if(roleId <= 0) {
                return;
            }

            if(!confirm(`Vil du slette rollen "${name}"?`)) {
                return;
            }

            ajaxLockActive = true;
            showTailwindPreloader();

            $.ajax({
                type: 'DELETE',
                url: ajaxPathRole + '/' + roleId,
                dataType: 'json'
            }).success(function (data) {
                $('#role_wrapper').html(data.html);
                reinitTransitions('#role_wrapper');
                $(document).find('#role_list_panel').notify(`Rolle "${name}" er slettet`, {
                    position: "bottom center",
                    className: 'success'
                });
                $('html, body').animate({scrollTop:0}, 'slow');
            }).error(function (data) {
                $(document).find('#role_btn_delete').notify(`Kunne ikke slette rollen`, {
                    position: "right",
                    className: 'error'
                });
            }).always(function () {
                ajaxLockActive = false;
                hideTailwindPreloader();
            });
            return false;
        });

        $(document).on('click', '#role_wrapper .role-item', function (e) {
            e.preventDefault();

            if (ajaxLockActive) {
                return false;
            }

            const roleId = $(this).attr('role-id');

            ajaxLockActive = true;
            showTailwindPreloader();

            $.ajax({
                type: 'GET',
                url: ajaxPathRole + '/' + roleId + ajaxPathRoleForm,
                dataType: 'json'
            }).success(function (data) {
                $('#role_form').html(data.html);
                reinitTransitions('#role_form');
                setActiveListItem('#role_list_panel .role-item', roleId, 'role-id');
            }).error(function (data) {
                $(document).find('#role_list_panel').notify(`Kunne ikke opprette rolle`, {
                    position: "bottom center",
                    className: 'error'
                });
            }).always(function () {
                ajaxLockActive = false;
                hideTailwindPreloader();
            });
            return false;
        });
    })();
});
